(function () {
  const SPECIFIC_ID = '6291'; // Free shipping, trigger = product cụ thể
  const ALL_ID = '6290';      // Gift, trigger = All products
  const GIFT_PROP = '_salepify-progress-bar';
  const DEBUG = false;

  // Escape hatch của app: == 1 thì dispatch CustomEvent thay vì tlHandleReRenderCart() (reload).
  window.TLCustomEventCartGoal = 1;

  const nativeXhrOpen = XMLHttpRequest.prototype.open;
  let ourFetch = window.fetch;
  let busy = false;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cleanId = (id) => (id ? String(id).replace(/[^0-9]/g, '') : '');

  function currentProductId() {
    const meta = (window.meta && window.meta.product)
      || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product);
    return meta ? cleanId(meta.id) : '';
  }

  function findRule(rules, id) {
    if (!rules || typeof rules !== 'object') return null;
    const key = Object.keys(rules).find(k => k.split('_')[0] === id);
    return key ? rules[key] : null;
  }

  function triggerProductIds(rule) {
    try {
      const ids = typeof rule.trigger_condition_ids === 'string'
        ? JSON.parse(rule.trigger_condition_ids)
        : (rule.trigger_condition_ids || []);
      return ids.map(item => cleanId(item.shopify_id || item.id || item));
    } catch (e) {
      return [];
    }
  }

  function isSpecificEligible(rule, cart) {
    if (!rule || rule.trigger_condition !== 'product') return false;

    const productId = currentProductId();
    const targetIds = triggerProductIds(rule);
    const pdpMatch = !!productId && targetIds.includes(productId);
    const cartMatch = !!cart && (cart.items || []).some(item =>
      !(item.properties && item.properties[GIFT_PROP]) && targetIds.includes(cleanId(item.product_id))
    );

    if (DEBUG) console.log('[Salepify] ', { productId, targetIds, pdpMatch, cartMatch });
    return pdpMatch || cartMatch;
  }

  function applyStatus(rules, cart) {
    const specific = findRule(rules, SPECIFIC_ID);
    const all = findRule(rules, ALL_ID);
    if (!specific) return null;

    const eligible = isSpecificEligible(specific, cart);
    specific.status = eligible;
    if (all) all.status = !eligible;
    return { id: eligible ? SPECIFIC_ID : ALL_ID, rule: eligible ? specific : all };
  }

  function installRuleGate() {
    const descriptor = Object.getOwnPropertyDescriptor(window, 'tlCartGoalRules');
    const setStatus = (rules) => {
      try {
        applyStatus(rules, null);
      } catch (e) {
        console.warn('[Salepify] Set status lỗi.', e);
      }
    };

    if (descriptor && !descriptor.configurable) {
      setStatus(descriptor.value);
      return;
    }

    let rules = descriptor ? descriptor.value : undefined;
    Object.defineProperty(window, 'tlCartGoalRules', {
      configurable: true,
      get: () => rules,
      set(value) {
        rules = value;
        setStatus(rules);
      }
    });
    if (rules !== undefined) setStatus(rules);
  }

  function builtOfferId() {
    try {
      const goal = window.tlCartGoalEmbed && window.tlCartGoalEmbed.cartGoal;
      return goal ? cleanId(goal.id) : '';
    } catch (e) {
      return '';
    }
  }

  function rebuildEmbed() {
    const oldEmbed = window.tlCartGoalEmbed;
    if (!oldEmbed || busy) return;

    busy = true;
    const nativeAddEventListener = window.addEventListener;

    try {
      oldEmbed.renderAllCartGoals = () => {};
      oldEmbed.updateAllCartGoals = () => {};
      oldEmbed.updateCartTotal = () => {};

      window.fetch = ourFetch;
      XMLHttpRequest.prototype.open = nativeXhrOpen;

      window.addEventListener = function (type) {
        if (String(type).startsWith('TLCARTGOAL:') || type === 'beforeunload') return;
        return nativeAddEventListener.apply(this, arguments);
      };

      document
        .querySelectorAll('.tl__cart-goal__container__drawer, .tl-custom-cart-goal-container, .tl__cart-goal__gift-modal')
        .forEach(el => el.remove());

      window.tlCartGoalEmbed = new oldEmbed.constructor(
        window.tlCartGoalIsRestricted,
        window.tlCartGoalRules,
        window.tlCartGoalGiftSVG,
        window.tlCartGoalDiscountSVG,
        window.tlCartGoalFreeShippingSVG,
        window.tlCartGoalCurrencySymbol,
        window.tlCartGoalCartTotal,
        window.tlCartGoalTemplate,
        window.tlCartGoalDefaultImage,
        window.tlCartGoalShowTrademark,
        window.tlCartGoalProductIdMapCollection,
        window.tlCartGoalDisplaySetting,
        window.tlCartGoalTranslation,
        window.tlCartGoalCustomer,
        window.tlCartGoalCartType,
        window.tlCartGoalPriceCalculation
      );
    } catch (e) {
      console.warn('[Salepify] Rebuild thất bại, giữ instance cũ.', e);
      window.tlCartGoalEmbed = oldEmbed;
    } finally {
      window.addEventListener = nativeAddEventListener;
      busy = false;
    }
  }

  function ruleDiscountCode(rule) {
    try {
      const parsed = typeof rule.product_discount === 'string'
        ? JSON.parse(rule.product_discount)
        : (rule.product_discount || {});
      return parsed.code || '';
    } catch (e) {
      return '';
    }
  }

  function cleanupInactiveOffer(cart, active) {
    if (busy) return;

    const activeRule = active.rule;
    const inactiveId = active.id === SPECIFIC_ID ? ALL_ID : SPECIFIC_ID;
    const inactiveRule = findRule(window.tlCartGoalRules, inactiveId);
    const body = {};

    const staleCode = inactiveRule && ruleDiscountCode(inactiveRule);
    const codes = (cart.discount_codes || []).map(d => d.code);
    if (staleCode && codes.includes(staleCode)) {
      body.discount = codes.filter(c => c !== staleCode).join(',');
    }

    // App chỉ tự dọn quà khi rule active bật auto_remove_gift.
    if (activeRule && !activeRule.auto_remove_gift) {
      const updates = {};
      (cart.items || []).forEach(item => {
        const prop = item.properties && item.properties[GIFT_PROP];
        if (prop && cleanId(String(prop).split('-')[0]) === inactiveId) updates[item.key] = 0;
      });
      if (Object.keys(updates).length) body.updates = updates;
    }

    if (!Object.keys(body).length) return;

    busy = true;
    fetch(root() + 'cart/update.js?app=salepify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .catch(e => console.warn('[Salepify] Dọn offer cũ lỗi.', e))
      .then(() => {
        busy = false;
        if (window.tlCartGoalEmbed) window.tlCartGoalEmbed.renderAllCartGoals();
      });
  }

  function syncFromCart() {
    fetch(root() + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        const active = applyStatus(window.tlCartGoalRules, cart);
        if (!active) return;

        const builtId = builtOfferId();
        if (builtId && builtId !== active.id && [SPECIFIC_ID, ALL_ID].includes(builtId)) rebuildEmbed();

        cleanupInactiveOffer(cart, active);
      })
      .catch(e => console.warn('[Salepify] Sync cart lỗi.', e));
  }

  function init() {
    const previousFetch = window.fetch;
    ourFetch = function () {
      const promise = previousFetch.apply(this, arguments);
      const url = arguments[0] ? String(arguments[0]) : '';
      const isCartMutation = /\/cart\/(add|change|update)/.test(url) && !url.includes('app=salepify');
      if (!isCartMutation) return promise;
      return promise.then(response => {
        if (!busy) setTimeout(syncFromCart, 250);
        return response;
      });
    };
    window.fetch = ourFetch;

    ['TLCustomEvent:CartGoal-handleAutoAddGift', 'TLCustomEvent:CartGoal-handleAddtoCart']
      .forEach(evt => window.addEventListener(evt, () => window.location.reload()));

    syncFromCart();
  }

  try {
    installRuleGate();
  } catch (e) {
    console.warn('[Salepify] Không cài được rule gate.', e);
  }

  const waitForApp = setInterval(() => {
    try {
      if (!window.tlCartGoalRules) return;
      clearInterval(waitForApp);
      init();
    } catch (e) {
      clearInterval(waitForApp);
      console.warn('[Salepify] Init lỗi.', e);
    }
  }, 50);
})();
